import type { InvoiceCheckoutQuote } from './bookings'
import { UserFacingError } from './errors'

export class InvoicePayLinkNotFoundError extends UserFacingError {
  constructor() {
    super('This payment link is invalid or has expired.')
    this.name = 'InvoicePayLinkNotFoundError'
  }
}

export class InvoiceNotPayableError extends UserFacingError {
  constructor() {
    super('This invoice can no longer be paid online.')
    this.name = 'InvoiceNotPayableError'
  }
}

export class InvoiceQuoteChangedError extends UserFacingError {
  readonly quote: InvoiceCheckoutQuote

  constructor(quote: InvoiceCheckoutQuote) {
    super('The total changed. Review the new total before paying.')
    this.name = 'InvoiceQuoteChangedError'
    this.quote = quote
  }
}

export class CheckoutInProgressError extends UserFacingError {
  constructor() {
    super('A payment is already in progress. Try again in a moment.')
    this.name = 'CheckoutInProgressError'
  }
}

export class CardDeclinedError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Your card was declined. Try a different card.')
    this.name = 'CardDeclinedError'
  }
}

export class CardNotSupportedError extends UserFacingError {
  constructor() {
    super('This payment method is not supported. Enter a credit or debit card.')
    this.name = 'CardNotSupportedError'
  }
}

export class InvalidConfirmationTokenError extends UserFacingError {
  constructor() {
    super('Your card details expired. Enter your card again.')
    this.name = 'InvalidConfirmationTokenError'
  }
}

export class CheckoutRateLimitedError extends UserFacingError {
  constructor() {
    super('Too many attempts. Please wait a few minutes and try again.')
    this.name = 'CheckoutRateLimitedError'
  }
}
